export class JobOwnership {
    id!: string
    isHot!: boolean
    job!: string
    jobFullName!: string
    jobStatus!: number
    name!: string
    assignedUserId!: number
    dueDate!: Date
    doneDate!: Date
    status!: number
    order!: number
    notes!: string
}
